import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useDevelopmentQueryKey} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.issue_references_updated)

export function useDevelopmentLiveUpdates(aliveChannels: AliveChannels | undefined): void {
  const queryKey = useDevelopmentQueryKey()

  useInvalidateOnAliveUpdate(queryKey ? aliveChannels?.pullRequest : undefined, queryKey ?? [], {filter})
}
